export const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    overviewPaper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        height: '67%',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    pageTagsPaper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        height: '60%',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    fullWidth: {
        width: '80%'
    },
    dialogActionsBtn: {
        margin: '8px 19px'
    },
    reviewsSearchResultsItems: {
        padding: 10,
    },
    searchReviewActionBtn: {
        float: 'right',
        lineHeight: '75px',
        marginRight: '15%',
    },
    headingReviewSearch: {
        display: 'flex',
        textAlign: 'justify'
    },
    reviewsOrderTitle: {
        paddingBottom: 15,
    },
    noAvailableReviews: {
        textAlign: 'center',
    },
    reviewsOrderItems: {
        border: '1px solid rgba(0, 0, 0, 0.24)',
        marginBottom: 5,
    },
    loadingText: {
        textAlign: 'center',
        color: '#757575',
        position: 'absolute',
        width: '100%',
        fontSize: '18px',
        left: 8,
        top: 73,
    },
    formTypeCaption: {
        padding: '10px 0'
    },
    searchReviews: {
        marginTop: 15,
    },
    faqsSearchResults: {
        marginRight: 10
    },
    faqsSearchResultsItems: {
        padding: 5,
    },
    headingFaqSearch: {
        display: 'flex',
    },
    faqsOrderTitle: {
        paddingBottom: 15,
    },
    noAvailableFaqs: {
        textAlign: 'center',
    },
    faqsOrderItems: {
        border: '1px solid rgba(0, 0, 0, 0.24)',
        marginBottom: 5,
    },
    searchFaqActionBtn: {
        float: 'right',
        margin: '5px 10px 0 0'
    },
    sectionLinkToPageChip: {
        marginBottom: 15,
        background: "#c1c0c0",
    },
    imageUploadSubheadingText: {
        marginBottom: 10,
    },
    sectionMeetUsPageLinkChip: {
        marginTop: 15,
        background: "#c1c0c0",
    },
});


// WEBPACK FOOTER //
// ./src/containers/builder/style/staff_section.js